/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefreshToken_refreshToken_Auth = { readonly __typename: 'Auth', readonly token: string };

export type RefreshToken_Mutation = { readonly __typename: 'Mutation', readonly refreshToken: RefreshToken_refreshToken_Auth | null };


export type RefreshTokenVariables = _Types.Exact<{ [key: string]: never; }>;


export type RefreshToken = RefreshToken_Mutation;


export const RefreshTokenDocument = gql`
    mutation RefreshToken {
  refreshToken {
    token
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshToken, RefreshTokenVariables>;

/**
 * __useRefreshToken__
 *
 * To run a mutation, you first call `useRefreshToken` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshToken` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshToken, { data, loading, error }] = useRefreshToken({
 *   variables: {
 *   },
 * });
 */
export function useRefreshToken(baseOptions?: Apollo.MutationHookOptions<RefreshToken, RefreshTokenVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshToken, RefreshTokenVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenHookResult = ReturnType<typeof useRefreshToken>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshToken>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshToken, RefreshTokenVariables>;